var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCloud = function SvgCloud(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 960",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M251 800q-88 0-149.5-61.5T40 589q0-78 50-137t127-71q20-97 94-158.5T482 161q112 0 189 81.5T748 438v24q72-2 122 46.5T920 631q0 69-50 119t-119 50z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCloud);
export default ForwardRef;